import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { StyledModal } from '../StyledModal';
import ActivationSuccessFooter from './ActivationSuccessFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActivationDuplicateErrorModal = ({
  onSuccess,
  upgradeData
}) => {
  return /*#__PURE__*/_jsxs(StyledModal, {
    centered: true,
    size: "auto",
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.duplicateErrorTitle",
          options: {
            upgradeProduct: I18n.text(`upgrades.products.${upgradeData.upgradeProduct}`)
          }
        })
      })
    }), /*#__PURE__*/_jsx(ActivationSuccessFooter, {
      onSuccess: onSuccess,
      showTrialLoadingState: false,
      upgradeData: upgradeData,
      ctaText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.activationModal.startSetup"
      }),
      featureName: null
    })]
  });
};
export default ActivationDuplicateErrorModal;